export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chevron-left.vue?vue&type=template&id=76a0b904&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-left.vue?vue&type=template&id=76a0b904&
// module id = 936
// module chunks = 0